export default "__VITE_ASSET__25bb922e__"